import { createFileRoute } from '@tanstack/react-router';
import { fallback, zodValidator } from '@tanstack/zod-adapter';
import { z } from 'zod';

import { Validate } from '@/features/agents';

export type ShowPanelType = 'agent-runs' | 'email';

const AgentRunsDetailsSearchSchema = z.object({
  showPanel: fallback(z.optional(z.enum(['agent-runs', 'email'])), undefined),
});

export const Route = createFileRoute('/_auth/details/agents/$agentId/runs/$runId')({
  component: Validate,
  notFoundComponent: () => {
    return <p>Agent Run not found!</p>;
  },
  validateSearch: zodValidator(AgentRunsDetailsSearchSchema),
});
